export function getCameraFov() {
  const DEF = 45;
  const MAX = 1500;
  let koef = 0;
  if(window.innerWidth < MAX) {
    koef = (1 - (window.innerWidth / MAX)) * DEF; 
  }
  return DEF + koef;
}